import React from 'react';
import { inject, observer } from 'mobx-react';
import UserLevelTooltip from '../UserLevelTooltip';
import progressBarSilver from '../../assets/icons/profile/Silver/progressBarSilver.svg';
import progressBarGold from '../../assets/icons/profile/Gold/progressBarGold.svg';
import progressBarPlatinum from '../../assets/icons/profile/Platinum/progressBarPlatinum.svg';
import styles from './styles.module.scss';

const getProgressBar = (level) => {
    switch (level) {
    case 'Silver':
        return progressBarSilver;
    case 'Gold':
        return progressBarGold;
    case 'Platinum':
        return progressBarPlatinum;
    default:
        return '';
    }
};

const UserLevelProgressBar = (props) => {
    const { store } = props;
    const { nextPeriod } = store.profile.user.level;

    if (nextPeriod) {
        const {
            level: nextPeriodLevel,
            requirementsForPromotionToSilver,
            requirementsForPromotionToGold,
            requirementsForPromotionToPlatinum,
        } = nextPeriod;
        return <div className={styles.UserLevelProgressBar}>
            <div className={styles.progressBarMask} data-level={nextPeriodLevel}>
                <UserLevelTooltip
                    period={'nextPeriod'}
                    level={'Silver'}
                    requirements={requirementsForPromotionToSilver}
                >
                    <div className={styles.silverPoint}/>
                </UserLevelTooltip>
                <UserLevelTooltip
                    period={'nextPeriod'}
                    level={'Gold'}
                    requirements={requirementsForPromotionToGold}
                >
                    <div className={styles.goldPoint}/>
                </UserLevelTooltip>
                <UserLevelTooltip
                    period={'nextPeriod'}
                    level={'Platinum'}
                    requirements={requirementsForPromotionToPlatinum}
                >
                    <div className={styles.platinumPoint}/>
                </UserLevelTooltip>
            </div>
            <img
                src={getProgressBar(nextPeriodLevel)}
                alt="Прогресс-бар"
                className={styles.UserLevelProgressBar__Image}/>

        </div>;
    }
    return null;
};

export default inject('store')(observer(UserLevelProgressBar));
